import { CanActivateFn, CanDeactivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { RoteiroWizardStore } from './wizard.store';
import { VisitPlanService } from '../../../core/services/visit-plan.service';
import { getStepNumber, hasReachedStep } from '../models/visit-plan';

export const unsavedChangesGuard: CanDeactivateFn<unknown> = () => {
  const wizardStore = inject(RoteiroWizardStore);

  if (!wizardStore.isDirty()) {
    return true;
  }

  return window.confirm('Você tem alterações não salvas. Deseja realmente sair?');
};

export const wizardStep2Guard: CanActivateFn = (route) => {
  const wizardStore = inject(RoteiroWizardStore);
  const router = inject(Router);

  if (wizardStore.isStep1Complete()) {
    return true;
  }

  const id = route.parent?.paramMap.get('id');
  if (!id) {
    router.navigate(['/roteirizacao/novo']);
    return false;
  }

  const visitPlanId = parseInt(id, 10);
  if (isNaN(visitPlanId)) {
    router.navigate(['/roteirizacao/novo']);
    return false;
  }

  const service = inject(VisitPlanService);

  return service.getVisitPlanDetails(visitPlanId).pipe(
    map((visitPlan): boolean | UrlTree => {
      wizardStore.setFromVisitPlan(visitPlan);

      if (!wizardStore.isStep1Complete()) {
        router.navigate([`/roteirizacao/editar/${id}`]);
        return false;
      }

      const stepNumber = getStepNumber(visitPlan.lastStep);
      if (hasReachedStep(stepNumber, 'RouteGeneration')) {
        return router.createUrlTree([`/roteirizacao/editar/${id}/visualizar-rotas`]);
      }

      return true;
    }),
    catchError(() => {
      router.navigate([`/roteirizacao/editar/${id}`]);
      return of(false);
    })
  );
};

export const wizardStep3Guard: CanActivateFn = (route) => {
  const wizardStore = inject(RoteiroWizardStore);
  const router = inject(Router);

  const hasSelectedCities = wizardStore.selectedCities().length > 0;

  if (hasSelectedCities) {
    return true;
  }

  const id = route.parent?.paramMap.get('id');
  if (id) {
    router.navigate([`/roteirizacao/editar/${id}/revisar-cidades`]);
  } else {
    router.navigate(['/roteirizacao/novo/revisar-cidades']);
  }

  return false;
};

export const wizardStep4Guard: CanActivateFn = (route) => {
  const wizardStore = inject(RoteiroWizardStore);
  const router = inject(Router);

  if (wizardStore.routes().length > 0) {
    return true;
  }

  const id = route.parent?.paramMap.get('id');
  if (id) {
    router.navigate([`/roteirizacao/editar/${id}/visualizar-rotas`]);
  } else {
    router.navigate(['/roteirizacao/novo/visualizar-rotas']);
  }

  return false;
};
